var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M13.3404 16.0649H4.66183C4.39826 16.0649 4.17969 15.8464 4.17969 15.5828V2.41708C4.17969 2.15351 4.39826 1.93494 4.66183 1.93494H13.3468C13.6104 1.93494 13.829 2.15351 13.829 2.41708V15.5828C13.829 15.8464 13.6104 16.0649 13.3468 16.0649H13.3404ZM5.13754 15.1007H12.8583V2.89922H5.14397V15.1007H5.13754Z",
          fill: "#676060",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M10.6973 12.4329H7.16797V13.3971H10.6973V12.4329Z",
          fill: "#676060",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }